





import Vue from "vue";
export default Vue.extend({
  props: {
    bgColor: {
      type: String
    }
  },
  computed: {
    _bgColor() {
      return {
        "background-color": this.bgColor ? this.bgColor : "#ffffff"
      };
    }
  }
});
